import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import Helmet from "react-helmet";
import { PRESCRIPTIONMAILVIEWS } from "common/viewContent";
import * as Path from "routes/Path/index";
import BackButtom from "components/BackButtom";
import { toast } from "react-toastify";

const PrescriptionDetails = () => {
  const location = useLocation();
  const [data, setData] = useState(location.state.summary || {});
  const [loading, setLoading] = useState(false);
  //const [search_text, setSearch_text] = useState("");
  const precription = JSON.parse(data.precription);

  return (
    <>
      {/* {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )} */}
      <Helmet title={PRESCRIPTIONMAILVIEWS.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <BackButtom />
          <h1>{PRESCRIPTIONMAILVIEWS.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.prescriptionMail}>
                Prescription Mail
              </Link>
            </div>
            <div className="breadcrumb-item">
              {PRESCRIPTIONMAILVIEWS.CURRENT_MODULE}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">
                    {PRESCRIPTIONMAILVIEWS.TOP_CONTENT}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          {!loading && (
            // data &&
            <div className="card p-3">
              <div className="border-bottom text-center mb-3">
                <h6 className="p-2">Prescription Details</h6>
              </div>
              <div className="commonTable" style={{ overflow: "scroll" }}>
                <table
                  style={{
                    width: "100%",
                    border: "1px solid rgba(221, 221, 221, 1)",
                    marginBottom: 20,
                    borderSpacing: 0,
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(221, 221, 221, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Name Of Drug
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(221, 221, 221, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Strength
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(221, 221, 221, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Strength Type
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(221, 221, 221, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Unit
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(221, 221, 221, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Form
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(221, 221, 221, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Dose
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(221, 221, 221, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Frequency
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(221, 221, 221, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Intakes or Applications
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(221, 221, 221, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Route
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(174, 213, 255, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Refills
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(174, 213, 255, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Quantity
                      </th>
                      <th
                        style={{
                          padding: 10,
                          border: "1px solid rgba(174, 213, 255, 1)",
                          backgroundPosition: "initial",
                          backgroundSize: "initial",
                          backgroundRepeat: "initial",
                          backgroundAttachment: "initial",
                          backgroundOrigin: "initial",
                          backgroundClip: "initial",
                          backgroundColor: "rgba(174, 213, 255, 1)",
                          fontWeight: 400,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Comments
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {precription.map((val, index) => {
                      return (
                        <>
                          <tr key={index}>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.medicine_name}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.strength}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            />
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.units}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.form}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.dose}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.frequency}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.intakes_applications}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.route}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.refills}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val.quantity}
                            </td>
                            <td
                              style={{
                                padding: 10,
                                border: "1px solid rgba(221, 221, 221, 1)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <p
                                className="m-0"
                                style={{ whiteSpace: "normal" }}
                              >
                                {val.comments}
                              </p>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="card p-3">
            <div className="border-bottom d-flex justify-content-between align-items-center mb-3 pb-2">
              <h6 className="p-2 m-0">Emails</h6>
              {/* <div>
                <input
                  className="form-control"
                  name="search_text"
                  placeholder="Search email..."
                  defaultValue=""
                  style={{ width: 250, height: 36, fontSize: 14 }}
                />
              </div> */}
            </div>
            {!loading && data?.emails && (
              <div className="d-flex flex-wrap gap-2">
                {data &&
                  data.emails.map((val, idx) => (
                    <span
                      key={idx}
                      className="badge bg-primary rounded-pill px-3 py-2"
                    >
                      {val}
                    </span>
                  ))}
              </div>
            )}

            <div className="card p-3">
              {!loading && data?.emails.length === 0 && (
                <p className="text-center py-5">No Email Found</p>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default PrescriptionDetails;
